import { Dataset } from '../../../types/types';
import { updateActiveFiltersFromLazyState } from '../../../utils/filters/updateActiveFiltersFromLazyState';
import { ExportLazyState } from '../types';

export const resolveSubsetFilters = (
  lazyState: ExportLazyState | undefined,
  subsetDataset: Dataset
): Record<string, unknown> | null => {
  if (!lazyState?.filters) {
    return null;
  }

  return updateActiveFiltersFromLazyState(null, lazyState, subsetDataset);
};
